import { render, staticRenderFns } from "./dataCenter.vue?vue&type=template&id=016cf762&scoped=true&"
import script from "./dataCenter.vue?vue&type=script&lang=js&"
export * from "./dataCenter.vue?vue&type=script&lang=js&"
import style0 from "./dataCenter.vue?vue&type=style&index=0&id=016cf762&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cf762",
  null
  
)

export default component.exports